document.querySelectorAll(".bundle_card").forEach(item => {
  if (item.dataset.bundleCardInitialized === "true") return
  item.dataset.bundleCardInitialized = "true"

  const modal_btn = item.querySelector(".bundle_card_btn")
  const modal_btn_two = item.querySelector(".bundle_card_bundlelist_text")
  const modal = item.nextElementSibling;

  // modal_btn.addEventListener("click", () => {
  //   openModal()
  // })
  // modal_btn_two.addEventListener("click", () => {
  //   openModal()
  // })
  item.addEventListener("click", () => {
    openModal()
  })

  // function openModal() {
  //   const originalParent = modal.parentElement;
  //   const nextSibling = modal.nextElementSibling;
  //   document.body.appendChild(modal);
  //   modal.style.display = 'block';
  //   document.body.classList.add("bundle_card_modals_show")

  //   modal.querySelector('.bundle_card_modal_close').addEventListener('click', closeModal);

  //   modal.addEventListener('click', (e) => {
  //     if (e.target === modal.querySelector(".bundle_card_modal_mask")) closeModal();
  //   });
  // }
  function openModal() {
    const originalParent = modal.parentElement;
    const nextSibling = modal.nextElementSibling;
    document.body.appendChild(modal);
    modal.style.display = 'block';
    document.body.classList.add("bundle_card_modals_show");

    initBundleModalPrices(modal);

    if (modal.dataset.bundleModalCloseBound !== "true") {
      modal.dataset.bundleModalCloseBound = "true"

      modal.querySelector('.bundle_card_modal_close').addEventListener('click', closeModal);

      modal.addEventListener('click', (e) => {
        if (e.target === modal.querySelector(".bundle_card_modal_mask")) closeModal();
      });
    }
  }

  function initBundleModalPrices(modal) {
    modal.querySelectorAll(".bundle_card_modal_product").forEach(productEl => {
      const productData = JSON.parse(
        productEl.querySelector('.bundle_card_modal_product_data').textContent
      );

      const currentVariantId = String(productEl.getAttribute("data-id"));
      const currentVariant = productData.product.variants.find(variant => {
        return String(variant.id) === currentVariantId;
      });

      if (currentVariant) {
        updateProductPrice(productEl, currentVariant);
      }
    });

    updateBundleSummary(modal);
  }

  function closeModal() {
    const originalParent = modal.parentElement;
    const nextSibling = modal.nextElementSibling;
    modal.style.display = 'none';
    document.body.classList.remove("bundle_card_modals_show")

    if (nextSibling) {
      originalParent.insertBefore(modal, nextSibling);
    } else {
      originalParent.appendChild(modal);
    }
  }

  const bundle_prodcuts = modal.querySelectorAll(".bundle_card_modal_product")

  bundle_prodcuts.forEach(item => {
    const type = item.getAttribute("data-type")
    const img = item.querySelector(".bundle_card_modal_product_img")
    const product_data = JSON.parse(
      item.querySelector('.bundle_card_modal_product_data').textContent
    );
    const product = product_data.product
    const preorder_info = product_data.preorderInfo || {}
    let variant
    const option_selects = item.querySelectorAll(".bundle_card_modal_product_option_item")

    option_selects.forEach(select => {
      select.addEventListener("click", () => {
        if (select.classList.contains("bundle_card_modal_product_option_item_active") || select.classList.contains("bundle_card_modal_product_option_item_diasbled")) return
        const select_parent = select.closest(".bundle_card_modal_product_option")
        const select_title = select_parent.querySelector(".bundle_card_modal_product_option_text span")
        select_parent.querySelector(".bundle_card_modal_product_option_item_active").classList.remove("bundle_card_modal_product_option_item_active")
        select.classList.add("bundle_card_modal_product_option_item_active")
        if (type === "chairs") {
          const color = select.getAttribute("data-color")
          const material = select.getAttribute("data-material")
          variant = product.variants.find(variant => variant.option1 === material && variant.option2 === color)
          select_title.innerHTML = color + " - " + material
        }
        if (type === "accessories") {
          const color = select.getAttribute("data-color")
          variant = product.variants.find(variant => variant.option1 === color)
          select_title.innerHTML = color
        }
        if (type === "desk") {
          const select_type = select_parent.getAttribute("data-type")
          const value = select.getAttribute("data-value")
          select_title.innerHTML = select_type === "Color" ? value : value + " " + select.getAttribute("data-size").replaceAll('/', '"')
          if (select_type === "Color") {
            const variants = product.variants.filter(variant => variant.option1 === value && variant.available)
            const size_selects = item.querySelectorAll(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_item")
            size_selects.forEach(size_select => {
              size_select.classList.remove("bundle_card_modal_product_option_item_diasbled")
              const size_value = size_select.getAttribute("data-value")
              if (!variants.find(variant => variant.option2 === size_value)) {
                size_select.classList.add("bundle_card_modal_product_option_item_diasbled")
              }
            })
            const active_size = item.querySelector(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_item_active").getAttribute("data-value")
            variant = variants.find(variant => variant.option2 === active_size)
            if (!variant) {
              variant = variants[0]
              size_selects.forEach(size_select => {
                size_select.classList.remove("bundle_card_modal_product_option_item_active")
                const size_value = size_select.getAttribute("data-value")
                if (size_value === variant.option2) {
                  size_select.classList.add("bundle_card_modal_product_option_item_active")
                  item.querySelector(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_text span").innerHTML = size_value + " " + size_select.getAttribute("data-size").replaceAll('/', '"')
                }
              })
            }

          }
          if (select_type === "Size") {
            const active_color = item.querySelector(".bundle_card_modal_product_option[data-type='Color'] .bundle_card_modal_product_option_item_active").getAttribute("data-value")
            variant = product.variants.find(variant => variant.option1 === active_color && variant.option2 === value)
          }
        }
        if (!variant) return
        changePriceShow(type, item, variant)
        updatePreorderInfo(item, variant, preorder_info)
        img.src = variant.featured_image.src
        item.setAttribute("data-id", variant.id)
      })
    })
  })

  function getCurrencyRate() {
    return Number(window.Shopify?.currency?.rate || 1);
  }

  function convertBaseCentsToPresentmentCents(baseCents) {
    return Math.round(Number(baseCents || 0) * getCurrencyRate());
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';

    const money = Shopify.formatMoney(Math.round(cents), window.money_format);

    // 2.279,00 kr -> 2.279 kr
    // €2,279.00 -> €2,279
    return money.replace(/([,.])00(\s?[^0-9]*)$/, '$2');
  }

  function getVariantBundleDiscountBaseCents(productEl, variant) {
    if (!variant) return 0;

    const productDataEl = productEl.querySelector(".bundle_card_modal_product_data");
    if (!productDataEl) return 0;

    try {
      const productData = JSON.parse(productDataEl.textContent);
      const discounts = productData.bundleDiscounts || {};
      return Number(discounts[String(variant.id)] || 0);
    } catch (error) {
      console.warn("Invalid bundle product data:", error);
      return 0;
    }
  }

  function getProductDiscountCents(productEl) {
    const priceEl = productEl.querySelector(".bundle_card_modal_product_price");
    return Number(priceEl?.dataset.discountCents || 0);
  }

  function updateProductPrice(productEl, variant) {
    const priceEl = productEl.querySelector(".bundle_card_modal_product_price");
    const discountBaseCents = getVariantBundleDiscountBaseCents(productEl, variant);
    const priceCents = Number(variant.price || 0);
    const compareAtPriceCents = Number(variant.compare_at_price || 0);
    const compareAtCents = compareAtPriceCents > priceCents ? compareAtPriceCents : priceCents;
    const bundleDiscountCents = Math.min(
      Math.max(convertBaseCentsToPresentmentCents(discountBaseCents), 0),
      priceCents
    );
    const nativeDiscountCents = compareAtCents - priceCents;
    const discountCents = nativeDiscountCents + bundleDiscountCents;
    const finalCents = priceCents - bundleDiscountCents;

    priceEl.dataset.priceCents = String(priceCents);
    priceEl.dataset.compareAtCents = String(compareAtCents);
    priceEl.dataset.discountBaseCents = String(discountBaseCents);
    priceEl.dataset.bundleDiscountCents = String(bundleDiscountCents);
    priceEl.dataset.discountCents = String(discountCents);

    // 商品行划线价始终取实际 price；compare-at 只参与既有汇总计算。
    const originalPriceClass = priceCents > finalCents ? "" : " hidden";

    priceEl.innerHTML = `
      <span class="bundle_card_modal_product_price_dp">${formatMoney(finalCents)}</span>
      <span class="bundle_card_modal_product_price_op${originalPriceClass}">${formatMoney(priceCents)}</span>
    `;
  }

  function getSelectedBundleOriginalCents(modal) {
    let total = 0;

    modal.querySelectorAll(".bundle_card_modal_product").forEach(productEl => {
      const priceEl = productEl.querySelector(".bundle_card_modal_product_price");
      total += Number(priceEl?.dataset.compareAtCents || priceEl?.dataset.priceCents || 0);
    });

    modal.querySelectorAll(".bundle_card_modal_freebox_item").forEach(freeEl => {
      total += Number(freeEl.dataset.priceCents || 0);
    });

    return total;
  }

  function getSelectedBundleDiscountCents(modal) {
    let total = 0;

    modal.querySelectorAll(".bundle_card_modal_product").forEach(productEl => {
      total += getProductDiscountCents(productEl);
    });

    modal.querySelectorAll(".bundle_card_modal_freebox_item").forEach(freeEl => {
      total += Number(freeEl.dataset.priceCents || 0);
    });

    return total;
  }

  function getSelectedBundleProductsDiscountCents(modal) {
    let total = 0;

    modal.querySelectorAll(".bundle_card_modal_product").forEach(productEl => {
      total += getProductDiscountCents(productEl);
    });

    return total;
  }

  function updateBundleSummary(modal) {
    const originalCents = getSelectedBundleOriginalCents(modal);
    const discountCents = getSelectedBundleDiscountCents(modal);
    const productsDiscountCents = getSelectedBundleProductsDiscountCents(modal);
    const extraDiscountPercent = Math.min(Math.max(Number(modal.dataset.extraDiscountPercent || 0), 0), 100);
    let paidProductsCents = 0;

    // 额外折扣只针对付费商品的 bundle 折后金额，赠品及 compare-at 差价不参与基数。
    if (extraDiscountPercent > 0) {
      modal.querySelectorAll(".bundle_card_modal_product_price").forEach(priceEl => {
        const priceCents = Number(priceEl.dataset.priceCents || 0);
        const bundleDiscountCents = Number(priceEl.dataset.bundleDiscountCents || 0);
        paidProductsCents += Math.max(priceCents - bundleDiscountCents, 0);
      });
    }

    const extraDiscountCents = Math.min(Math.round(paidProductsCents * extraDiscountPercent / 100), paidProductsCents);
    const totalDiscountCents = discountCents + extraDiscountCents;
    const finalCents = Math.max(originalCents - totalDiscountCents, 0);

    const bundleSaveEl = modal.querySelector(".bundle_card_modal_salebox_list_price");
    const extraDiscountEl = modal.querySelector(".bundle_card_modal_extra_discount_amount");
    const totalSaveEl = modal.querySelector(".bundle_card_modal_saletotal_save");
    const totalOpEl = modal.querySelector(".bundle_card_modal_saletotal_op");
    const totalDpEl = modal.querySelector(".bundle_card_modal_saletotal_dp");

    if (bundleSaveEl) {
      bundleSaveEl.innerHTML = formatMoney(productsDiscountCents);
    }

    if (extraDiscountEl) {
      extraDiscountEl.dataset.discountCents = String(extraDiscountCents);
      extraDiscountEl.textContent = `-${formatMoney(extraDiscountCents)}`;
    }

    if (totalSaveEl) {
      totalSaveEl.innerHTML = formatMoney(totalDiscountCents);
    }

    if (totalOpEl) {
      totalOpEl.dataset.priceCents = String(originalCents);
      totalOpEl.innerHTML = `Was ${formatMoney(originalCents)}`;
    }

    if (totalDpEl) {
      totalDpEl.dataset.priceCents = String(finalCents);
      totalDpEl.innerHTML = formatMoney(finalCents);
    }
  }

  function changePriceShow(type, item, variant) {
    if (!variant) return;

    const modal = item.closest(".bundle_card_modal");

    updateProductPrice(item, variant);
    updateBundleSummary(modal);
  }

  function updatePreorderInfo(item, variant, preorder_info) {
    const preorder_text = preorder_info[String(variant.id)] || ""

    item.querySelectorAll(".bundle_card_modal_product_preorder_info").forEach(preorder_info_el => {
      preorder_info_el.textContent = preorder_text
      preorder_info_el.classList.toggle("hidden", !preorder_text)
    })

    updateBundleFreeGiftModule(item, preorder_text)
  }

  function updateBundleFreeGiftModule(productEl, preorderText) {
    const freeGift = productEl.querySelector(".bundle_card_modal_free_gift")
    if (!freeGift) return

    const titleEl = freeGift.querySelector(".bundle_card_modal_free_gift_title")
    if (titleEl) titleEl.textContent = preorderText

    freeGift.classList.toggle("hidden", !preorderText)

    if (!preorderText) {
      freeGift.querySelectorAll(".bundle_card_modal_free_gift_item").forEach(item => {
        item.classList.remove("is_active")
        item.setAttribute("aria-pressed", "false")
      })
    }
    
    updateBundleFreeGiftExclusions(productEl.closest(".bundle_card_modal"))
  }

  function getBundleFreeGiftSelection(giftItem) {
    if (!giftItem) return null

    return {
      giftLines: giftItem.getAttribute("data-gift-lines") || "",
      giftTitle: giftItem.getAttribute("data-gift-title") || ""
    }
  }

  function isSameBundleFreeGift(firstSelection, secondSelection) {
    if (!firstSelection || !secondSelection) return false

    if (firstSelection.giftLines && secondSelection.giftLines) {
      return firstSelection.giftLines === secondSelection.giftLines
    }

    return Boolean(
      firstSelection.giftTitle
      && secondSelection.giftTitle
      && firstSelection.giftTitle === secondSelection.giftTitle
    )
  }

  function getBundlePreorderGiftPair(modal) {
    if (!modal) return null

    const eligibleProducts = [...modal.querySelectorAll(".bundle_card_modal_product")].filter(productEl => {
      const productType = productEl.getAttribute("data-type")
      const freeGift = productEl.querySelector(".bundle_card_modal_free_gift")

      return (productType === "chairs" || productType === "desk")
        && freeGift
        && !freeGift.classList.contains("hidden")
        && freeGift.querySelector(".bundle_card_modal_free_gift_item")
    })
    const chairs = eligibleProducts.filter(productEl => productEl.getAttribute("data-type") === "chairs")
    const desks = eligibleProducts.filter(productEl => productEl.getAttribute("data-type") === "desk")

    if (chairs.length !== 1 || desks.length !== 1 || eligibleProducts.length !== 2) return null

    return { chair: chairs[0], desk: desks[0] }
  }

  function clearBundleFreeGiftSelection(productEl) {
    productEl?.querySelectorAll(".bundle_card_modal_free_gift_item").forEach(giftItem => {
      giftItem.classList.remove("is_active")
      giftItem.setAttribute("aria-pressed", "false")
    })
  }

  function resetBundleFreeGiftExclusions(modal) {
    modal?.querySelectorAll('[data-preorder-gift-excluded]').forEach(giftItem => {
      giftItem.hidden = false
      giftItem.removeAttribute("data-preorder-gift-excluded")
    })
  }

  function applyBundleFreeGiftExclusion(productEl, excludedSelection) {
    productEl.querySelectorAll(".bundle_card_modal_free_gift_item").forEach(giftItem => {
      const shouldExclude = isSameBundleFreeGift(
        getBundleFreeGiftSelection(giftItem),
        excludedSelection
      )

      giftItem.hidden = shouldExclude
      giftItem.toggleAttribute("data-preorder-gift-excluded", shouldExclude)
    })
  }

  function updateBundleFreeGiftExclusions(modal, preferredProductEl = null) {
    resetBundleFreeGiftExclusions(modal)

    const pair = getBundlePreorderGiftPair(modal)
    if (!pair) return

    let chairSelection = getBundleFreeGiftSelection(
      pair.chair.querySelector(".bundle_card_modal_free_gift_item.is_active")
    )
    let deskSelection = getBundleFreeGiftSelection(
      pair.desk.querySelector(".bundle_card_modal_free_gift_item.is_active")
    )

    if (isSameBundleFreeGift(chairSelection, deskSelection)) {
      const productToClear = preferredProductEl === pair.desk ? pair.chair : pair.desk
      clearBundleFreeGiftSelection(productToClear)
      chairSelection = getBundleFreeGiftSelection(
        pair.chair.querySelector(".bundle_card_modal_free_gift_item.is_active")
      )
      deskSelection = getBundleFreeGiftSelection(
        pair.desk.querySelector(".bundle_card_modal_free_gift_item.is_active")
      )
    }

    applyBundleFreeGiftExclusion(pair.chair, deskSelection)
    applyBundleFreeGiftExclusion(pair.desk, chairSelection)
  }

  function initBundleFreeGiftPicker(modal) {
    modal.querySelectorAll(".bundle_card_modal_free_gift_item").forEach(giftItem => {
      if (giftItem.dataset.freeGiftBound === "true") return
      giftItem.dataset.freeGiftBound = "true"

      giftItem.addEventListener("click", event => {
        event.stopPropagation()
        
        if (giftItem.hidden || giftItem.hasAttribute("data-preorder-gift-excluded")) return

        const container = giftItem.closest(".bundle_card_modal_free_gift")
        if (!container) return

        container.querySelectorAll(".bundle_card_modal_free_gift_item").forEach(item => {
          item.classList.remove("is_active")
          item.setAttribute("aria-pressed", "false")
        })

        giftItem.classList.add("is_active")
        giftItem.setAttribute("aria-pressed", "true")
        
        updateBundleFreeGiftExclusions(modal, container.closest(".bundle_card_modal_product"))
      })
    })
    
    updateBundleFreeGiftExclusions(modal)
  }

  function getSelectedBundleFreeGiftLines(productEl, parentVariantId) {
    const freeGift = productEl.querySelector(".bundle_card_modal_free_gift")
    if (!freeGift || freeGift.classList.contains("hidden")) return []

    const selectedGift = freeGift.querySelector(".bundle_card_modal_free_gift_item.is_active")
    if (!selectedGift) return []

    const linesData = selectedGift.getAttribute("data-gift-lines")
    if (!linesData) return []

    let giftLines = []
    try {
      giftLines = JSON.parse(linesData)
    } catch (error) {
      console.warn("Invalid bundle free gift data:", error)
      return []
    }

    const catalogHandle = freeGift.getAttribute("data-free-gift-catalog-handle") || ""
    const giftTitle = selectedGift.getAttribute("data-gift-title") || ""

    return giftLines
      .filter(line => line && line.id)
      .map(line => ({
        id: line.id,
        quantity: Number(line.quantity) || 1,
        properties: {
          _free_gift: "true",
          _free_gift_catalog: catalogHandle,
          _free_gift_title: giftTitle,
          _free_gift_parent_variant: String(parentVariantId)
        }
      }))
  }

  function getBundleProductPreorderValue(productEl, variantId) {
    const productDataEl = productEl.querySelector(".bundle_card_modal_product_data")
    if (!productDataEl) return ""

    try {
      const productData = JSON.parse(productDataEl.textContent)
      return productData.preorderInfo?.[String(variantId)] || ""
    } catch (error) {
      console.warn("Invalid bundle product data:", error)
      return ""
    }
  }

  // initBundleFreeGiftPicker(modal)

  const addBundleToCartBtn = modal.querySelector(".bundle_card_modal_btn")
  addBundleToCartBtn.addEventListener("click", async (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (addBundleToCartBtn.classList.contains("is_loading")) return

    const cartIcon = document.querySelector(".header--cart .header__icon--cart");
    let cartFormData = { items: [] };
    const preorderGiftPair = getBundlePreorderGiftPair(modal)
    const preorderGiftProducts = preorderGiftPair
      ? new Set([preorderGiftPair.chair, preorderGiftPair.desk])
      : new Set()
    const selectedPreorderGifts = []

    modal.querySelectorAll(".bundle_card_modal_product").forEach(item => {
      const parentVariantId = item.getAttribute("data-id")
      const parentItem = { id: parentVariantId, quantity: 1 }
      const preorderValue = getBundleProductPreorderValue(item, parentVariantId)

      if (preorderValue) {
        const formattedPreorderDate = window.extractAndFormatDate(preorderValue)
        parentItem.properties = {
          'Pre-order': formattedPreorderDate
        }
      }

      cartFormData.items.push(parentItem)
      
      const selectedGiftItem = item.querySelector(".bundle_card_modal_free_gift_item.is_active")
      const selectedGift = getBundleFreeGiftSelection(selectedGiftItem)
      if (
        preorderGiftProducts.has(item)
        && selectedPreorderGifts.some(selection => isSameBundleFreeGift(selection, selectedGift))
      ) return

      if (preorderGiftProducts.has(item) && selectedGift) {
        selectedPreorderGifts.push(selectedGift)
      }
      
      // getSelectedBundleFreeGiftLines(item, parentVariantId).forEach(line => {
      //   cartFormData.items.push(line)
      // })
    })
    modal.querySelectorAll(".bundle_card_modal_freebox_item").forEach(item => {
      cartFormData.items.push({ id: item.getAttribute("data-id"), quantity: 1 })
    })
    addBundleToCartBtn.classList.add("is_loading");
    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartFormData),
      });

      Shopify.getCart((cartTotal) => {
        document.body.classList.add("cart-sidebar-show");
        updateSidebarCart(cartTotal);
      });
    } finally {
      addBundleToCartBtn.classList.remove("is_loading");
      closeModal()
      setTimeout(() => cartIcon?.click(), 0);
    }
  })
})
